import {
  ChangeDetectorRef,
  Component,
  effect,
  inject,
  input,
  output,
  untracked,
} from '@angular/core';
import { EnumDtoOfUserPackageStatus, PackagesClient, UserPackageStatus } from '../../model/fss.api';
import { firstValueFrom } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { Dot } from '../../icons/dot/dot';
import { Select } from 'primeng/select';
import { ChevronRight } from '../../icons/chevron-right/chevron-right';

@Component({
  standalone: true,
  selector: 'app-package-status-dropdown',
  imports: [Select, FormsModule, Dot, ChevronRight],
  templateUrl: './package-status-dropdown.html',
  styleUrl: './package-status-dropdown.scss',
})
export class PackageStatusDropdown {
  private readonly _client = inject(PackagesClient);
  private readonly _cdr = inject(ChangeDetectorRef);

  reset = input(0);
  options: EnumDtoOfUserPackageStatus[] | undefined;
  selectedOption: EnumDtoOfUserPackageStatus | undefined;

  dropdownStyle = {
    colorScheme: {
      light: {
        root: {
          background: 'transparent',
          filledHoverBackground: '#F7F8FA',
          filledFocusBackground: '#F7F8FA',
          color: '#181D27',
          borderColor: 'transparent',
          focusBorderColor: 'transparent',
          filledFocusBorderColor: 'transparent',
          hoverBorderColor: 'transparent',
          shadow: 'none',
        },
      },
    },
  };

  onSelect = output<UserPackageStatus | undefined>();

  constructor() {
    this._getStatuses().then((res) => {
      this.options = res.result;
      this._cdr.detectChanges();
    });

    effect(() => {
      this.reset();
      untracked(() => this.selectedOption = undefined);
    });
  }

  getStrokeByStatus(status: UserPackageStatus) {
    switch (status) {
      case UserPackageStatus.NEW:
        return '#2970FF';
      case UserPackageStatus.INVOICE_SENT:
        return '#F79009';
      case UserPackageStatus.ACTIVE:
      case UserPackageStatus.EXTENDED:
        return '#17B26A';
      case UserPackageStatus.EXPIRED:
        return '#7E838F';
      default:
        return '#F04438';
    }
  }

  private async _getStatuses() {
    return await firstValueFrom(this._client.getPackageStatusesForDropdown());
  }
}
